<script>
  export let pageName;

  import AcceptCancelDialog from "./AcceptCancelDialog.svelte";

  import dictionaryES from "../utils/dictionary/dictionary-ES";
  import dictionaryEN from "../utils/dictionary/dictionary-EN";

  import { dictionary, language } from "../utils/stores.js";
  import { getToken, setToken, getLanguage, setLanguage } from "../utils/token";
  import { post } from "../utils/api";

  import { onMount } from "svelte";

  let dict;

  let cerrarSesionButton;
  let logoutRequest = false;

  let isReviewer = false;
  let isEditor = false;
  let isChiefEditor = false;

  onMount(async () => {
    const response = await post("RolUsuario", { token: getToken() }, "json");
    isReviewer = response.revisor;
    isEditor = response.editor;
    isChiefEditor = response.editorJefe;
    changeLanguage(getLanguage());
  });

  let changeLanguage = lang => {
    switch (lang) {
      case "es":
        dictionary.set(dictionaryES);
        break;
      case "en":
        dictionary.set(dictionaryEN);
        break;
    }
    setLanguage(lang);
    language.set(lang);
  };

  let logout = () => {
    setToken("");
    location.href = "/login";
  };

  const unsubscribe = dictionary.subscribe(value => {
    dict = value;
  });

  $: if (cerrarSesionButton) {
    cerrarSesionButton.childNodes[0].textContent = dict["cerrarSesion"];
    if (cerrarSesionButton.childNodes[1]) {
      cerrarSesionButton.childNodes[1].textContent = dict["cerrarSesion"];
    }
  }
</script>

<!-- Page Header-->
<header class="section page-header">
  <!-- RD Navbar-->
  <div class="rd-navbar-wrap">
    <nav
      class="rd-navbar rd-navbar-modern"
      data-layout="rd-navbar-fixed"
      data-sm-layout="rd-navbar-fixed"
      data-md-layout="rd-navbar-fixed"
      data-md-device-layout="rd-navbar-fixed"
      data-lg-layout="rd-navbar-fixed"
      data-lg-device-layout="rd-navbar-fixed"
      data-xl-layout="rd-navbar-static"
      data-xl-device-layout="rd-navbar-static"
      data-xxl-layout="rd-navbar-static"
      data-xxl-device-layout="rd-navbar-static"
      data-lg-stick-up-offset="10px"
      data-xl-stick-up-offset="10px"
      data-xxl-stick-up-offset="10px"
      data-lg-stick-up="true"
      data-xl-stick-up="true"
      data-xxl-stick-up="true">
      <div class="rd-navbar-main">
        <!-- RD Navbar Panel-->
        <div class="rd-navbar-panel">
          <!-- RD Navbar Toggle-->
          <button
            class="rd-navbar-toggle"
            data-rd-navbar-toggle=".rd-navbar-nav-wrap">
            <span />
          </button>
          <!-- RD Navbar Brand-->
          <div class="rd-navbar-brand">
            <a
              class="brand"
              href="http://www.farmaceuticosdesevilla.es/"
              target="_blank">
              <img class="menuLogo" src="/images/revista/logo.png" alt="Logo" />
            </a>
          </div>
        </div>
        <div class="rd-navbar-nav-wrap">
          <ul class="rd-navbar-nav">
            <li
              class="rd-nav-item {pageName === 'Editor' ? 'active' : ''}"
              style={isChiefEditor ? '' : 'display: none'}>
              <a class="rd-nav-link" href="#null">{dict['editorJefe']}</a>
              <div class="rd-menu rd-navbar-megamenu">
                <ul class="rd-navbar-megamenu-inner">
                  <li class="rd-megamenu-item">
                    <ul class="rd-megamenu-list">
                      <li class="rd-megamenu-list-item">
                        <a
                          class="rd-megamenu-list-link"
                          href="/articulos-editor">
                          {dict['misArticulosEditorJefe']}
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="rd-nav-item {pageName === 'Editor' ? 'active' : ''}"
              style={isEditor && !isChiefEditor ? '' : 'display: none'}>
              <a class="rd-nav-link" href="#null">{dict['editor']}</a>
              <div class="rd-menu rd-navbar-megamenu">
                <ul class="rd-navbar-megamenu-inner">
                  <li class="rd-megamenu-item">
                    <ul class="rd-megamenu-list">
                      <li class="rd-megamenu-list-item">
                        <a
                          class="rd-megamenu-list-link"
                          href="/articulos-editor">
                          {dict['misArticulosEditor']}
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="rd-nav-item {pageName === 'Revisor' ? 'active' : ''}"
              style={isChiefEditor || isReviewer ? '' : 'display: none'}>
              <a class="rd-nav-link" href="#null">{dict['revisor']}</a>
              <div class="rd-menu rd-navbar-megamenu">
                <ul class="rd-navbar-megamenu-inner">
                  <li class="rd-megamenu-item">
                    <ul class="rd-megamenu-list">
                      <li class="rd-megamenu-list-item">
                        <a
                          class="rd-megamenu-list-link"
                          href="/articulos-revisor">
                          {dict['misArticulosRevisor']}
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </li>
            <li class="rd-nav-item {pageName === 'Autor' ? 'active' : ''}">
              <a class="rd-nav-link" href="#null">{dict['autor']}</a>
              <div class="rd-menu rd-navbar-megamenu">
                <ul class="rd-navbar-megamenu-inner">
                  <li class="rd-megamenu-item">
                    <ul class="rd-megamenu-list">
                      <li class="rd-megamenu-list-item">
                        <a
                          class="rd-megamenu-list-link"
                          href="/enviar-articulo">
                          {dict['enviararticulo']}
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li class="rd-megamenu-item">
                    <ul class="rd-megamenu-list">
                      <li class="rd-megamenu-list-item">
                        <a
                          class="rd-megamenu-list-link"
                          href="/articulos-autor">
                          {dict['misArticulos']}
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </li>
            <li class="rd-nav-item {pageName === 'Perfil' ? 'active' : ''}">
              <a class="rd-nav-link" href="#null">{dict['opciones']}</a>
              <div class="rd-menu rd-navbar-megamenu">
                <ul class="rd-navbar-megamenu-inner">
                  <li class="rd-megamenu-item">
                    <ul class="rd-megamenu-list">
                      <li class="rd-megamenu-list-item">
                        <a class="rd-megamenu-list-link" href="/cuenta">
                          {dict['miCuenta']}
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    class="rd-megamenu-item"
                    style={isChiefEditor ? '' : 'display: none'}>
                    <ul class="rd-megamenu-list">
                      <li class="rd-megamenu-list-item">
                        <a class="rd-megamenu-list-link" href="/usuarios">
                          {dict['usuarios']}
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li class="rd-megamenu-item">
                    <ul class="rd-megamenu-list">
                      <li class="rd-megamenu-list-item">
                        <a
                          class="rd-megamenu-list-link"
                          href="/legal"
                          target="_blank">
                          {dict['legalidad']}
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="rd-navbar-element bg-accent">
          <a
            class="button button-sm button-header"
            href="#null"
            bind:this={cerrarSesionButton}
            on:click={() => window.$('#logout').modal('show')}>
            {dict['cerrarSesion']}
          </a>
        </div>
        <img
          class="language"
          src="/images/revista/spain.svg"
          alt="Spanish"
          on:click={() => changeLanguage('es')} />
        <img
          class="language"
          src="/images/revista/uk.svg"
          alt="English"
          on:click={() => changeLanguage('en')} />
        <div class="rd-navbar-dummy" />
      </div>
    </nav>
  </div>
  <AcceptCancelDialog
    id="logout"
    titulo={dict['cerrarSesion']}
    tituloAceptar={dict['aceptar']}
    tituloCancelar={dict['cancelar']}
    aceptarAction={() => logout()}
    text={dict['preguntaCerrarSesion']} />
</header>
